import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import unitModule from './unit'
import compareModule from './compare'
import settingModule from './setting'

const persistedState = createPersistedState({
  paths: ['unit', 'setting'],
})

export default createStore({
  state: {
    systemState: 'active',
  },
  mutations: {
    setSystemState (state, payload) {
      state.systemState = payload
    },
  },
  modules: {
    unit: unitModule,
    compare: compareModule,
    setting: settingModule,
  },
  plugins: [persistedState],
})
